import React from 'react';

import styles from './Timeline.module.scss';

const Timeline = ({ content, isLast }) => {
	return (
		<div className={styles.timelineContainer}>
			<div className={styles.timelineItem}>
				<div className={styles.lineWrapper}>
					<div className={styles.dot}></div>
					{!isLast ? <div className={styles.line}></div> : null}
				</div>
				{content}
			</div>
		</div>
	);
};

export default Timeline;
